import { makeFormatter } from 'afformative';
import { formatPhone } from '@ci/utils';

export const PhoneFormatter = makeFormatter(formatPhone, { displayName: 'PhoneFormatter' });
